import NumberCard from "./src/number-card.vue";

export default NumberCard;
